export interface ReactiveFormSubmitDuplicateErrorDetectorOptions {
  readonly error: unknown;
  readonly hasClientExistsError: boolean;
}

/** Detects duplicate-record request failures without depending on concrete backend error shapes. */
export class ReactiveFormSubmitDuplicateErrorDetector {
  public isDuplicateError(
    options: ReactiveFormSubmitDuplicateErrorDetectorOptions,
  ): boolean {
    if (options.hasClientExistsError) {
      return true;
    }

    if (options.error === null || typeof options.error !== 'object') {
      return false;
    }

    const errorRecord = options.error as Record<string, unknown>;
    const nestedError = errorRecord['error'];
    const nestedErrorRecord =
      nestedError !== null && typeof nestedError === 'object'
        ? (nestedError as Record<string, unknown>)
        : null;
    const values = [
      errorRecord['code'],
      errorRecord['status'],
      errorRecord['message'],
      nestedErrorRecord?.['code'],
      nestedErrorRecord?.['message'],
    ].map((value) => String(value ?? '').toLowerCase());

    return values.some(
      (value) =>
        value.includes('exists') ||
        value.includes('duplicate') ||
        value.includes('already') ||
        value.includes('duplicado') ||
        value.includes('ya existe') ||
        value === '409',
    );
  }
}
